import { render, staticRenderFns } from "./ReferralRow.vue?vue&type=template&id=19ddf582&scoped=true"
import script from "./ReferralRow.vue?vue&type=script&lang=js"
export * from "./ReferralRow.vue?vue&type=script&lang=js"
import style0 from "./ReferralRow.vue?vue&type=style&index=0&id=19ddf582&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ddf582",
  null
  
)

export default component.exports